import { combineReducers } from "redux";
import {carpentersReducer} from './carpenter';
import {carpentersDetailReducer} from './carpenterDetail';
const rootCarpentersReducer = combineReducers({
  carpentersReducer: carpentersReducer,
  carpentersDetailReducer: carpentersDetailReducer
});
export default rootCarpentersReducer;
